var _path, _rect, _path2, _path3, _path4, _path5, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgItemAnimation02(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 96,
    viewBox: "0 0 82 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3553 6.79831C18.2113 3.0437 21.9489 0.693881 25.7035 1.54983L59.9696 9.36156L67.0118 10.967L74.054 12.5724L74.5261 12.68C78.2807 13.536 80.6305 17.2736 79.7745 21.0282L64.4505 88.2471C63.5945 92.0017 59.857 94.3516 56.1023 93.4956L7.27977 82.3654C3.52516 81.5095 1.17533 77.7719 2.03127 74.0173L17.3553 6.79831Z",
    fill: "#01C060"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 25.2242,
    y: 10.052,
    width: 46.878,
    height: 6.27416,
    transform: "rotate(12.8424 25.2242 10.052)",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.77805,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4846 23.649L67.8491 33.9909",
    stroke: "white",
    strokeWidth: 1.77805,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7966 31.0503L66.1612 41.3921",
    stroke: "white",
    strokeWidth: 1.77805,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1096 38.4521L64.4741 48.794",
    stroke: "white",
    strokeWidth: 1.77805,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4216 45.8534L62.7862 56.1952",
    stroke: "white",
    strokeWidth: 1.77805,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15.3947,
    y: 53.1777,
    width: 15.626,
    height: 7.52156,
    transform: "rotate(12.8424 15.3947 53.1777)",
    stroke: "white",
    strokeWidth: 1.77805,
    strokeLinecap: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 30.6302,
    y: 56.651,
    width: 15.626,
    height: 7.52156,
    transform: "rotate(12.8424 30.6302 56.651)",
    stroke: "white",
    strokeWidth: 1.77805,
    strokeLinecap: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 45.8644,
    y: 60.124,
    width: 15.626,
    height: 7.52156,
    transform: "rotate(12.8424 45.8644 60.124)",
    stroke: "white",
    strokeWidth: 1.77805,
    strokeLinecap: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 13.7229,
    y: 60.5111,
    width: 15.626,
    height: 7.52156,
    transform: "rotate(12.8424 13.7229 60.5111)",
    stroke: "white",
    strokeWidth: 1.77805,
    strokeLinecap: "round"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 12.051,
    y: 67.8446,
    width: 15.626,
    height: 7.52156,
    transform: "rotate(12.8424 12.051 67.8446)",
    stroke: "white",
    strokeWidth: 1.77805,
    strokeLinecap: "round"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 28.9585,
    y: 63.9844,
    width: 15.626,
    height: 7.52156,
    transform: "rotate(12.8424 28.9585 63.9844)",
    stroke: "white",
    strokeWidth: 1.77805,
    strokeLinecap: "round"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 27.2867,
    y: 71.3179,
    width: 15.626,
    height: 7.52156,
    transform: "rotate(12.8424 27.2867 71.3179)",
    stroke: "white",
    strokeWidth: 1.77805,
    strokeLinecap: "round"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 44.1926,
    y: 67.4574,
    width: 15.626,
    height: 7.52156,
    transform: "rotate(12.8424 44.1926 67.4574)",
    stroke: "white",
    strokeWidth: 1.77805,
    strokeLinecap: "round"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 42.5208,
    y: 74.7908,
    width: 15.626,
    height: 7.52156,
    transform: "rotate(12.8424 42.5208 74.7908)",
    stroke: "white",
    strokeWidth: 1.77805,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemAnimation02);
export default __webpack_public_path__ + "static/media/item-animation-02.0d5f1d1b152137a14e06e194c5af6b92.svg";
export { ForwardRef as ReactComponent };